import { render, staticRenderFns } from "./EmbeddedChatBottom.vue?vue&type=template&id=5bcff61e&"
import script from "./EmbeddedChatBottom.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedChatBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports